/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: NDLA
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const AccessibilityFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20m0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16" />
    <path
      fillRule="evenodd"
      d="M10 4a1.6 1.6 0 0 0 0 3.22c.88 0 1.6-.72 1.6-1.61S10.89 4 10 4m4.5 4.06c0-.66-.59-1.25-1.3-1.11q-.52.1-.98.21a8 8 0 0 1-2.21.32h-.02a8 8 0 0 1-2.21-.32l-.98-.21c-.71-.14-1.3.45-1.3 1.11 0 .51.36.98.88 1.09q.93.25 1.87.48-.02 1.01-.17 2.01a12 12 0 0 1-.62 1.94l-.34.92c-.22.62.15 1.38.86 1.49a1.1 1.1 0 0 0 1.2-.74l.82-2.43.82 2.43c.17.49.66.82 1.2.74.7-.12 1.08-.87.86-1.5l-.34-.9c-.25-.66-.49-1.3-.62-1.95a14 14 0 0 1-.17-2l1.87-.5c.52-.1.87-.57.88-1.08"
      clipRule="evenodd"
    />
  </Icon>
);
